import { userActions } from 'entities/user/model';
import { error, request, success } from 'shared/api';
import { SagaPayload } from 'shared/types/globals';
import { camelize, logger } from 'shared/utils';
import { call, put, takeLatest } from 'typed-redux-saga';

import { userApi } from '../ajax';

export function* getUserInfoSaga({ type, payload }: SagaPayload<typeof userActions.getUserInfo>) {
  yield* put(request(type));
  try {
    const data = yield* call(userApi.getUser);
    yield* put(userActions.updateUserState(camelize(data)));
    yield* put(success(type));
  } catch (err) {
    yield* put(error(type, err));
    logger('getUserInfo', err);
  }
}

export default function* listener() {
  yield takeLatest(userActions.getUserInfo.type, getUserInfoSaga);
}
